(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('SeekingSettingsDialogController', SeekingSettingsDialogController);

    SeekingSettingsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SeekingSettings', 'GenderEnum'];

    function SeekingSettingsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SeekingSettings, GenderEnum) {
        var vm = this;

        vm.seekingSettings = entity;
        vm.clear = clear;
        vm.save = save;
        vm.genderenums = GenderEnum.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.seekingSettings.id !== null) {
                SeekingSettings.update(vm.seekingSettings, onSaveSuccess, onSaveError);
            } else {
                SeekingSettings.save(vm.seekingSettings, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:seekingSettingsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
